/**
 * The session idle window, shared by the server's session read
 * (core/auth-repo.ts findLiveSessionByTokenHash — the enforcement) and the
 * client shell (client/app.tsx — the idle triple's bound), so the two cannot
 * drift: the client's auto-lock and keepalive are derived from the same figure
 * the server forgets a session by. Pure constant only: this module is part of
 * the client bundle and must never import node built-ins (the `pin-rules.ts`
 * shape).
 *
 * ⭐ T2075 M6 (board 2074, R-17, plan A1/D14): 300 s, down from 900 s. The
 * literal is pinned once, in test/core/auth-repo.spec.ts, so a silent change
 * here reds rather than sliding every derived arm along with it.
 * ⭐ Board 2706: 660 s. The client lock moved to 600 s (Alex), and the D14 bound
 * (client/app.tsx) needs only this window above the lock and above the
 * K + L − N restart gap, so it is the smallest whole minute past the lock: the window is
 * also how long a reopened app skips the PIN.
 */
export const SESSION_IDLE_MS = 660 * 1000; // 660 s
